import React, { FunctionComponent } from 'react'
import styles from './DateRangePicker.module.sass'
import List from '../../lists/List/List'
import { addDays, endOfMonth, startOfMonth, startOfToday, startOfYear } from 'date-fns'
import { DateTuple, RangePicker } from '../DatePicker/DatePicker'
import { values } from 'fp-ts-std/Record'

export type DateRange = 'now' | '7days' | '30days' | 'month' | 'year' | 'infinity' | 'unknown'

interface Variant {
    key: DateRange,
    text: string,
    getDates: (now: Date) => DateTuple;
}

export const DATE_RANGES: Record<DateRange, Variant> = {
    'now': {
        key: 'now',
        text: 'Сегодня',
        getDates: now => [now, now],
    },
    '7days': {
        key: '7days',
        text: 'На 7 дней',
        getDates: now => [now, addDays(now, 7)],
    },
    '30days': {
        key: '30days',
        text: 'На 30 дней',
        getDates: now => [now, addDays(now, 30)],
    },
    'month': {
        key: 'month',
        text: 'Этот месяц',
        getDates: now => [startOfMonth(now), endOfMonth(now)],
    },
    'year': {
        key: 'year',
        text: 'Этот год',
        getDates: now => [startOfYear(now), now],
    },
    'infinity': {
        key: 'infinity',
        text: 'За всё время',
        getDates: () => [undefined, undefined],
    },
    'unknown': {
        key: 'unknown',
        text: 'Неизвестен',
        getDates: () => [undefined, undefined]
    }
}

const rangesArray = values(DATE_RANGES).filter(range => range.key !== 'unknown')

interface Props {
    value?: DateTuple,
    onChange?: (value: DateTuple) => void,
    alignSelf?: boolean,
}

const DateRangePicker: FunctionComponent<Props> = props => {
    return <div className={styles.dateRangePicker}>
        <List
            className={styles.sidebar}
            toClassName={() => styles.item}
            data={rangesArray}
            toKey={variant => variant.key}
            render={item => item.text}
            onClick={item => props.onChange?.(item.getDates(startOfToday()))}
        />
        <div>
            <RangePicker
                numberOfMonths={2}
                value={props.value}
                onChange={props.onChange}
            />
        </div>
    </div>
}

export default DateRangePicker